import React from "react";

export default function LaborDayFrame6({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-lab61{fill:#a56c46}.cls-lab62{fill:#493324}.cls-lab63{fill:#663d1b}"
            }
          </style>
        </defs>
        <path
          d="M1770.9 512.94c-20.11-29.67-54.08-49.16-92.62-49.16H321.71c-38.53 0-72.52 19.51-92.63 49.17-12.11 17.87-19.18 39.43-19.18 62.65v973.33c0 61.75 50.06 111.81 111.81 111.81h1356.57c61.75 0 111.81-50.06 111.81-111.81V575.6c0-23.22-7.07-44.78-19.2-62.66ZM1464.38 727.2v767.3c0 44.59-36.14 80.73-80.73 80.73h-767.3c-44.59 0-80.73-36.14-80.73-80.73V727.2c0-39.8 28.78-72.86 66.68-79.5 4.56-.81 9.26-1.22 14.05-1.22h767.3c4.79 0 9.49.42 14.05 1.22 37.9 6.64 66.68 39.71 66.68 79.5Z"
          className="cls-lab63"
        />
        <path
          d="M1790.1 553.09v584.79c0 .39 0 .77-.01 1.16-.61 48.8-40.37 88.15-89.3 88.15h-236.42V727.2c0-39.8-28.78-72.86-66.68-79.5-4.56-.81-9.26-1.22-14.05-1.22h-767.3c-4.79 0-9.49.42-14.05 1.22-37.9 6.64-66.68 39.71-66.68 79.5v499.99H299.2c-49.33 0-89.31-39.98-89.31-89.31V553.09c0-49.33 39.98-89.31 89.31-89.31h1401.59c49.32 0 89.31 39.98 89.31 89.31Z"
          style={{
            fill: "#84522c",
          }}
        />
        <path
          d="M1790.1 553.1v94.6h-392.41a72.52 72.52 0 0 0-14.05-1.36h-767.3c-4.79 0-9.49.46-14.05 1.36H209.9v-94.6c0-20.89 7.18-40.11 19.18-55.32 16.36-20.71 41.68-33.99 70.13-33.99H1700.8c28.43 0 53.74 13.29 70.1 33.98 12.03 15.21 19.21 34.43 19.21 55.33Z"
          className="cls-lab61"
        />
        <path
          d="M1263.32 400.94v187.39h-91.77V454.29c0-27.5-32.49-49.79-72.57-49.79H901.01c-40.08 0-72.59 22.3-72.59 49.79v134.04h-91.76V400.94c0-34.07 40.25-61.69 89.92-61.69h346.82c49.67 0 89.92 27.61 89.92 61.69Z"
          className="cls-lab62"
        />
        <rect
          width={166.66}
          height={71.34}
          x={698.72}
          y={531.5}
          className="cls-lab63"
          rx={23.25}
          ry={23.25}
        />
        <rect
          width={166.66}
          height={71.34}
          x={1134.61}
          y={531.5}
          className="cls-lab63"
          rx={23.25}
          ry={23.25}
        />
        <path
          d="M493.26 647.7H385.83l30.21-183.92h107.44L493.26 647.7z"
          className="cls-lab62"
        />
        <path
          d="M493.46 646.47H385.82v691.1c17.91 16.4 35.81 32.81 53.72 49.21l53.92-49.21v-691.1Z"
          className="cls-lab62"
        />
        <path
          d="m436.98 1362.09-18.81-24.54 3.14-2.4 15.68 20.46.28-.36 3.13 2.41-3.41 4.44Zm22.55-29.31-3.13-2.41 14.9-19.37v-5.6h3.95v6.94l-15.72 20.43Zm-56.71-21.4h-3.95V1280h3.95v31.38Zm72.43-37.35h-3.95v-31.38h3.95v31.38Zm-72.43-25.41h-3.95v-31.38h3.95v31.38Zm72.43-37.35h-3.95v-31.38h3.95v31.38Zm-72.43-25.41h-3.95v-31.38h3.95v31.38Zm72.43-37.35h-3.95v-31.38h3.95v31.38Zm-72.43-25.41h-3.95v-31.38h3.95v31.38Zm72.43-37.35h-3.95v-31.38h3.95v31.38Zm-72.43-25.41h-3.95v-31.38h3.95v31.38Zm72.43-37.35h-3.95v-31.38h3.95v31.38Zm-72.43-25.4h-3.95v-31.38h3.95v31.38Zm72.43-37.35h-3.95v-31.38h3.95v31.38Zm-72.43-25.4h-3.95v-31.38h3.95v31.38Zm72.43-37.35h-3.95v-31.38h3.95v31.38Zm-72.43-25.4h-3.95v-31.38h3.95v31.38Zm72.43-37.35h-3.95v-31.38h3.95v31.38Zm-72.43-25.41h-3.95v-31.38h3.95v31.38Zm72.43-37.35h-3.95V740.6h3.95v31.38Zm-72.43-25.41h-3.95v-31.38h3.95v31.38Zm72.43-37.35h-3.95v-31.38h3.95v31.38Zm-72.43-25.41h-3.95v-31.38h3.95v31.38Zm72.84-37-3.9-.63 4.97-30.98 3.9.63-4.97 30.98Zm-67.89-24.85-3.89-.68 5.43-30.9 3.89.68-5.43 30.9Zm77.84-37.11-3.9-.63 4.97-30.98 3.9.63-4.97 30.98Zm-66.99-24.7-3.89-.68 5.43-30.9 3.89.68-5.43 30.9Zm76.93-37.26-3.9-.63 4.97-30.98 3.9.63-4.97 30.98Zm-66.08-24.55-3.89-.68 4.48-25.54 8.71-.12.06 3.95-5.44.08-3.92 22.32Zm40.73-22.85-.06-3.95 31.37-.45.06 3.95-31.37.45Z"
          className="cls-lab61"
        />
        <circle cx={439.65} cy={1227.19} r={60.2} className="cls-lab61" />
        <path
          d="M1511.67 647.7h107.43l-30.22-183.92h-107.43l30.22 183.92z"
          className="cls-lab62"
        />
        <path
          d="M1511.46 646.47h107.64v691.1c-17.91 16.4-35.81 32.81-53.72 49.21l-53.92-49.21v-691.1Z"
          className="cls-lab62"
        />
        <path
          d="m1567.95 1362.09-3.41-4.44 3.13-2.41.28.36 15.68-20.46 3.14 2.4-18.81 24.54Zm-22.55-29.31-15.72-20.43v-6.94h3.95v5.6l14.9 19.37-3.13 2.41Zm60.66-21.4h-3.95V1280h3.95v31.38Zm-72.43-37.35h-3.95v-31.38h3.95v31.38Zm72.43-25.41h-3.95v-31.38h3.95v31.38Zm-72.43-37.35h-3.95v-31.38h3.95v31.38Zm72.43-25.41h-3.95v-31.38h3.95v31.38Zm-72.43-37.35h-3.95v-31.38h3.95v31.38Zm72.43-25.41h-3.95v-31.38h3.95v31.38Zm-72.43-37.35h-3.95v-31.38h3.95v31.38Zm72.43-25.41h-3.95v-31.38h3.95v31.38Zm-72.43-37.35h-3.95v-31.38h3.95v31.38Zm72.43-25.4h-3.95v-31.38h3.95v31.38Zm-72.43-37.35h-3.95v-31.38h3.95v31.38Zm72.43-25.4h-3.95v-31.38h3.95v31.38Zm-72.43-37.35h-3.95v-31.38h3.95v31.38Zm72.43-25.4h-3.95v-31.38h3.95v31.38Zm-72.43-37.35h-3.95v-31.38h3.95v31.38Zm72.43-25.41h-3.95v-31.38h3.95v31.38Zm-72.43-37.35h-3.95V740.6h3.95v31.38Zm72.43-25.41h-3.95v-31.38h3.95v31.38Zm-72.43-37.35h-3.95v-31.38h3.95v31.38Zm72.43-25.41h-3.95v-31.38h3.95v31.38Zm-76.79-37-4.97-30.98 3.9-.63 4.97 30.98-3.9.63Zm67.89-24.85-5.43-30.9 3.89-.68 5.43 30.9-3.89.68Zm-77.84-37.11-4.97-30.98 3.9-.63 4.97 30.98-3.9.63Zm66.99-24.7-5.43-30.9 3.89-.68 5.43 30.9-3.89.68Zm-76.93-37.26-4.97-30.98 3.9-.63 4.97 30.98-3.9.63Zm66.08-24.55-3.92-22.32-5.44-.08.06-3.95 8.71.12 4.48 25.54-3.89.68Zm-40.73-22.85-31.37-.45.06-3.95 31.37.45-.06 3.95Z"
          className="cls-lab61"
        />
        <circle cx={1565.28} cy={1227.19} r={60.2} className="cls-lab61" />
        {children}
      </g>
    </svg>
  );
}
